export const ENCODE_TIMESTAMP_SEI_MESSAGE_UUID: Uint8Array = new Uint8Array([
  0x08, 0x2c, 0x96, 0x8f, 0x77, 0x5e, 0x49, 0xb4, 0x8d, 0x55, 0xa4, 0x29, 0xec, 0xd9, 0x89, 0xd5,
]);

const ENCODE_TIMESTAMP_SEI_MESSAGE_UUID_STRING: string = String.fromCharCode(...ENCODE_TIMESTAMP_SEI_MESSAGE_UUID);

export const extractEncodeTimestampFromExtraData: (extradata: string) => [] | [number, number] = (extradata) => {
  const [pts, base64Data] = extradata.split(';');
  const uint8SideData: Uint8Array = Uint8Array.from(atob(base64Data), (c) => c.charCodeAt(0));
  if (String.fromCharCode(...uint8SideData.slice(0, 16)) !== ENCODE_TIMESTAMP_SEI_MESSAGE_UUID_STRING) {
    return [];
  }

  const timestampSlice: Uint8Array = uint8SideData.slice(16, 24);

  let timestamp: number = 0;
  for (let i: number = timestampSlice.length - 1; i >= 0; i--) {
    timestamp += timestampSlice[i] * 256 ** i;
  }

  return pts && timestamp ? [Number(pts), timestamp] : [];
};
